import "./index.css";

import { Button, Drawer, Grid, Layout, Row, theme } from "antd";
import { useEffect, useState } from "react";

import { AiOutlineBell } from "react-icons/ai";
import Logo from "./Logo";
import MenuMobile from "../util-components/MenuMobile";
import { MenuOutlined } from "@ant-design/icons";
import Profile from "./Profile";
import SideBar from "./SideBar";

const { useBreakpoint } = Grid;

const { useToken } = theme;
const { Header } = Layout;
export const HeaderNav = ({ toggle, collapsed }) => {
  const screens = useBreakpoint();
  const [searchActive, setSearchActive] = useState(false);

  const { token } = useToken();
  const [viewPortWidth, setViewPortWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setViewPortWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  return (
    <Header
      id='header-md '
      style={{
        backgroundColor: '#05204e',
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        lineHeight: 0,
      }}
    >
      <div style={{
        display: "flex",
        flexDirection: "row-reverse",
        gap: "20px",

      }}>
        <Drawer
          className="drawer-menu"
          placement="left"
          open={collapsed}
          onClose={toggle}
          style={{
            overflow: "auto",
            height: "100%",
            padding: 0
          }}
          width={screens?.md ? "500px" : "80%"}
        >
          <MenuMobile />
        </Drawer>
        <Logo />
        {!(viewPortWidth >= 993) ? (
          <Button type="primary" onClick={toggle}>
            <MenuOutlined style={{ fontSize: "20px" }} />
          </Button>
        ) : null}
      </div>
      <Row
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          justifyContent: "center",
        }}
      >
        <AiOutlineBell size={20} color="#FFF" />
        <Profile />
      </Row>
    </Header>
  );
};

export default HeaderNav;
